import styled from 'styled-components';
import { mediaIpad, mediaIpadmini, mediaMobile  } from './responsize.js';

export const HeaderContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
`
export const IndexContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const BoxContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  ${ mediaIpadmini.Ipadmini`
    width: 100%;
  ` }
  ${ mediaIpad.Ipad`
    width: 100%;
  ` }
  ${ mediaMobile.Mobile`
    width: 100%;
  ` }
`

export const Channel = styled.div`

  ${ mediaIpadmini.Ipadmini`
    width: 80%;
  ` }
  ${ mediaIpad.Ipad`
    width: 80%;
  ` }
  ${ mediaMobile.Mobile`
    width: 80%;
  ` }
`
export const Text = styled.div`
  width: 25%;
  display: flex;
  justify-content: flex-end;
  padding-right: 2%;
`
export const TableContainer = styled.div`
  width: 90%;
  ${ mediaIpadmini.Ipadmini`
    width: 90%;
  ` }
  ${ mediaIpad.Ipad`
    width: 90%;
  ` }
  ${ mediaMobile.Mobile`
    width: 90%;
  ` }
`

export const ChartContainer = styled.div`
  width: 60%;
  ${ mediaIpadmini.Ipadmini`
    width: 90%;
  ` }
  ${ mediaIpad.Ipad`
    width: 90%;
  ` }
  ${ mediaMobile.Mobile`
    width: 90%;
  ` }
`

export const ChartAllContainer = styled.div`
  width: 80%;
  ${ mediaIpadmini.Ipadmini`
    width: 90%;
  ` }
  ${ mediaIpad.Ipad`
    width: 90%;
  ` }
  ${ mediaMobile.Mobile`
    width: 90%;
  ` }
`

export const BoxTableContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  ${ mediaIpadmini.Ipadmini`
    width: 100%;
  ` }
  ${ mediaIpad.Ipad`
    width: 100%;
  ` }
  ${ mediaMobile.Mobile`
    width: 100%;
  ` }
`



// WEBPACK FOOTER //
// ./src/components/pages/styled-components/index.js